import { Trophy, Mic, Crown, Flame, Star, Award } from "lucide-react";

const ICONS = {
    trophy: Trophy,
    mic: Mic,
    crown: Crown,
    flame: Flame,
    star: Star,
    award: Award,
};

export default function BadgeIcon({ badge, size = "md", earned = true }) {
    const Icon = ICONS[badge?.icon] || Award;
    const sizes = {
        sm: "w-10 h-10",
        md: "w-14 h-14",
        lg: "w-20 h-20",
    };
    const iconSizes = {
        sm: "w-5 h-5",
        md: "w-7 h-7",
        lg: "w-10 h-10",
    };
    const color = badge?.color || "#EE722E";
    return (
        <div
            className={`${sizes[size]} rounded-2xl flex items-center justify-center transition-all ${
                earned ? "" : "opacity-25 grayscale"
            }`}
            style={{
                background: earned
                    ? `linear-gradient(135deg, ${color}, ${color}cc)`
                    : "rgba(255,255,255,0.04)",
                boxShadow: earned ? `0 6px 20px ${color}55` : "none",
                border: earned ? "none" : "1px dashed rgba(255,255,255,0.1)",
            }}
            title={badge?.name}
            data-testid={`badge-${badge?.badge_id}`}
        >
            <Icon
                className={iconSizes[size]}
                color={earned ? "#181818" : "#888"}
                strokeWidth={2.5}
            />
        </div>
    );
}
